function parsePhoneNumbers(phone) {
  const parts = phone.split('-');

  const tel = `+1${parts[0]}${parts[1]}${parts[2]}`;
  const vanityPhone = `1 (${parts[0]}) ${parts[1]} EMMA`

  return { tel, vanityPhone }
}

function openChatSupport() {
  if (!window.fcWidget.isOpen()) {
    window.fcWidget.open();
  }
}

function getComparisonCompetitor(competitors) {
  const params = new URLSearchParams(window.location.search)
  const competitorParam = params.get('competitor') ?? 'Casper'
  const competitor = competitors.find(c => c.brandRoute === competitorParam)
  return competitor ?? competitors.find(c => c.brandRoute === 'Casper')
}

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0
});

const Currency = {
  format: (n, options) => {
    const defaultOptions = {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: n % 1 === 0 ? 0 : 2
    }

    return new Intl.NumberFormat('en-US', {
      ...defaultOptions,
      ...options
    }).format(n)
  }
}


function isFunction(obj) {
  return !!(obj && obj.constructor && obj.call && obj.apply);
}

function isNumber(n) {
  return typeof n === 'number' && isFinite(n);
}

function waitUntil(conditionFunction) {
  const poll = resolve => {
    if (conditionFunction()) resolve();
    else setTimeout(_ => poll(resolve), 400);
  }

  return new Promise(poll);
}

async function requestCart(payload = {}, url = '/cart/add.js') {
  try {
    const state = await fetch(`${url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/json` },
      body: JSON.stringify({ ...payload })
    });
    return await state.json();
  } catch (e) {
    return null;
  }
}

function getCrossSellProducts() {
  return [...document.querySelectorAll('product-cross-sell')]
    .map(block => block.getAddToCartData())
    .filter(block => block.isAdded)
    .flatMap(block => [
      {
        quantity: block.quantity,
        id: block.crossSellVariantId,
        properties: {
          ...(block.hasGWP && { hasGWP: true }),
        },
      },
      ...(block.hasGWP
        ? [
          {
            quantity: block.quantity,
            id: block.crossSellVariantId,
            properties: {
              freeGift: true,
            },
          },
        ]
        : [])
    ]);
}
